import { SagaIterator } from 'redux-saga';
import { put, call, takeLatest, StrictEffect } from 'redux-saga/effects';
import { fetchMyReports, fetchMyReportsError, fetchMyReportsSearch, fetchMyReportsSuccess, fetchMyReportsEnhancedSearch } from './index';
import { apiInstance } from 'src/services/interceptor';
import { PayloadAction } from '@reduxjs/toolkit';

function* getMyReports(): SagaIterator {
  try {
    const response = yield call(apiInstance, `/user/issues`);
    yield put(fetchMyReportsSuccess(response.data));
  } catch (e) {
    yield put(fetchMyReportsError());
  }
}

interface PayloadProps {
  reportNumber?: string | null;
  searchType?: string | null;
  search?: string | null;
  status?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  nextToken?: string | null;
}

function* getMyReportsSearch({
  payload: { reportNumber = '', status = '', dateFrom = '', dateTo = '', nextToken = '' },
}: PayloadAction<PayloadProps>): SagaIterator {
  try {
    const response = yield call(
      apiInstance,
      `/user/issues?search=${reportNumber}&status=${
        status || ''
      }&dateFrom=${dateFrom}&dateTo=${dateTo}&nextToken=${nextToken}`,
    );
    yield put(fetchMyReportsSuccess(response.data));
  } catch (e) {
    yield put(fetchMyReportsError());
  }
}

function* getMyReportsEnhancedSearch({
  payload: { status = '', dateFrom = '', dateTo = '', nextToken = '', searchType = '', search = '' },
}: PayloadAction<PayloadProps>): SagaIterator {
  try {
    let newSearchType = searchType
    let newSearchText = search
    if (!search) {
      newSearchText = ''
      newSearchType = ''
    }
    const response = yield call(
      apiInstance,
      `/user/issues?search=${newSearchText}&searchType=${newSearchType}&status=${status || ''
      }&dateFrom=${dateFrom}&dateTo=${dateTo}&nextToken=${nextToken}`,
    );
    yield put(fetchMyReportsSuccess(response.data));
  } catch (e) {
    yield put(fetchMyReportsError());
  }
}

function* myReportsSaga(): Generator<StrictEffect, void> {
  yield takeLatest(fetchMyReports.type, getMyReports);
  yield takeLatest(fetchMyReportsSearch.type, getMyReportsSearch);
  yield takeLatest(fetchMyReportsEnhancedSearch.type, getMyReportsEnhancedSearch)
}

export { myReportsSaga };
